export function getFirstErrorMessage (exception) {
  const message = (
    exception?.inner?.find(Boolean)?.message ||
    exception?.errors?.find(Boolean) ||
    exception?.response?.data?.message ||
    null
  )

  return Array.isArray(message) ? '' : message
}

export default function getValidationErrors (exception) {
  const validationErrors = exception.inner.reduce(
    (result, error) => {
      return Object.assign({}, result, {
        [error.path]: error.message
      })
    }, {})

  return validationErrors
}
